import { React, useEffect } from 'react';
import {Typography} from '@mui/material';

const Terms = () => {
    // Scroll to the top when the component is mounted
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

  return (
    <>

        <div style={{width:"90%", margin: '0 auto', padding: '20px 0'}}> 
        <Typography variant="h6" className="HeaderContent" gutterBottom sx={{marginTop:'5px', padding:'0px 0px 20px 0px'}} > 利用規約 </Typography> 
        {/* <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
            エン・ジャパン株式会社（以下「エン・ジャパン」といいます）が提供する転職支援サービスのご利用にあたっては、以下の利用規約をご確認、ご承諾いただいたうえでお申込みくださいますようお願い致します。
        </Typography> */}

        

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 第１条（規約の適用） </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        転ナビ経理利用規約（以下「本規約」といいます。）は、株式会社ビジネスビジョン（以下「当社」といいます。）が管理運営する転ナビ経理（以下「本サービス」といいます。）にかかる契約（以下「本契約」といいます。）に関して定めたものであり、本サービスの利用申込をした求人企業（以下「求人企業」といいます。）と当社との間に対して適用されるものとします。       
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 第２条（基本用語の定義）  </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        本規約において使用する基本用語の定義は、次のとおりとします。   <br />
        （１）求人情報：求人企業における求人情報をいいます。 <br />
        （２）求人企業：本サービスを利用する求人者をいいます。法人でない団体、個人等を含みます。<br />
        （３）求人企業情報：求人企業における企業情報をいいます。社名・所在地など、求人情報に含まれる情報も含みます。 <br />
        （４）求人企業関連情報：求人情報、求人企業情報、求人企業における本サービスの利用履歴情報、求人企業が保有する利用会員に関する情報（利用会員の選考状況等を含む）等をいいます。求人企業における本サービスの利用履歴情報には、利用内容および利用期間、求人企業からの当社への報告内容等の他、求人企業における利用者の氏名、権限設定内容および通知設定内容など、利用者単位の情報も含みます。<br /> 
        （５）利用会員：本サービスを利用する求職者をいいます。 <br />
        （６）利用会員情報：利用会員の情報をいい、レジュメ情報等、個人情報を含みます。利用会員情報には、利用会員が本サービスの利用にあたり登録した情報の他、本サービスにおける利用履歴（応募やメッセージ等の内容など）の情報も含みます。 <br />
        （7）エントリー依頼：求人企業からのスカウトに対し利用会員が初回返信することをいいます。 <br />
        （8）採用決定手数料：求人企業と当社との間の契約において、利用会員が内定承諾の上、入社したことの対価として、求人企業が当社に支払う事が定められている金銭の総額をいいます。 <br />
        （9）理論年収：基本給に一切の諸手当（通勤手当および所定外労働手当は除く）を加算した月額給与12か月分と賞与算定基準額に前年度実績賞与支給月数を乗じた賞与想定額を加算した額をいいます（ただし、年俸制を採用する場合は年俸額とする） <br />
        （10）内定承諾：本サービスを通じてエントリー依頼または求人企業への応募があった利用会員に対して、求人企業が採用の意思表示をした後、利用会員の入社予定日および理論年収について、求人企業と利用会員との間で合意することをいいます。 <br />
        （11）入社：本サービスを通じてエントリー依頼または求人企業への応募があった利用会員が、内定承諾の際に合意した入社予定日、または実質的な勤務（研修、内定承諾以降における試用期間としてのアルバイト勤務等を含みますがこれらに限りません。）を開始した日のいずれか早い日を迎えることをいいます。求人企業と当該利用会員の間の手続きの有無を要件としません。<br />
        （12）企業登録：本サービス利用における初回登録をいいます。 <br />
        （13）会社情報登録：企業登録後の求人企業情報登録をいいます。 
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 第３条（サービス内容） </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        1.求人企業は、本サービスにおいて、以下のサービスを利用することができます。   <br />
            （１）求人情報の掲載  <br />
            （２）利用会員の検索およびレコメンド  <br />
            （３）利用会員へのスカウト送信  <br />
            （４）利用会員とのやりとり（メッセージなど）  <br />
            （５）利用会員に関する採用選考の進捗管理  <br />
            2.当社は、前項のサービスを提供するために、以下の業務を行います。 <br />
            （１）利用会員情報および求人企業関連情報の取得および利用   <br />
            （２）利用会員情報について、利用者の同意に基づく求人企業への提供  <br />
            （３）本サービスの継続的な改善検討   <br />
            （４）問い合わせ対応および不正対策等本サービスの運営<br />
            （５）その他前各号に付随関連する業務  
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 第４条（本サービスの利用申し込み）</Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px', fontSize: '12px'}}> 
        求人企業は、本サービスの利用を申し込む場合には、本サービスの内容を理解した上で申し込むものとします。   
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}>第５条（企業審査） </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        当社は、求人企業について、本サービスの利用開始前後を問わず、当社基準に照らして審査します。当社は、当社基準に照らし、求人企業による本サービスの利用が不適切と判断した場合には、本サービスの利用開始前後を問わず、当社からの一方的な通知に基づき、契約の終了または本サービスの利用停止をすることができるものとします。求人企業は、本条に基づき契約が終了した場合には、期限の利益を喪失し、直ちに当社に対する一切の債務を弁済するものとします。   
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 第６条（本サービスの利用上の注意点） </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        1.当社は、本サービスの利用会員数や利用状況等について、一切の保証を行いません。 <br />
        2.求人企業は、自らが雇用主となる採用のためにのみ本サービスを利用するものとし、その他の目的（求人企業自らの商業目的等を含む）で本サービスを利用することはできません。グループ会社等が雇用主となる採用をしたい場合には、当該グループ会社等が本サービスに関する契約を締結の上、本サービスを利用する必要があります。 <br />
        3.求人企業は、利用会員から別途同意を得てグループ会社等に利用会員情報を提供したとしても、本サービスを用いずにグループ会社等から利用会員にスカウトや募集条件を明示することはできないことについて、予め承諾するものとします。求人企業は、グループ会社等から利用会員にスカウトや募集条件を明示したい場合には、本サービスを用いて行う必要があることについて、予め承諾するものとします。 <br />
        4.本サービスの利用において、利用環境（端末、システム環境またはブラウザなど）次第では、本サービスの一部または全部を利用できない場合があります。<br />
        5.当社は、労働施策総合推進法、職業安定法、個人情報保護法その他各種法令等（以下あわせて「法令等」といいます。）に抵触する可能性のある業務を受託しません。<br />
        6.本サービスに関する一切の著作権は、当社が有するものとします。ただし、求人企業または求人企業から委託を受けた第三者が作成した原稿、写真および企業ロゴ等の著作物については、この限りではありません。求人企業は、当社が、求人企業の採用活動支援目的および第三者へのマーケティング目的その他の当社の業務遂行に必要な範囲内で当社が当該著作物を利用すること、当該利用にあたり当社が当該著作物を自由に複製・改変・削除等を行うことを予め承諾するものとし、著作者人格権を有する場合でも、行使しないものとしますが、当該著作物の利用に関して当社への要望が発生した場合には、求人企業と当社で誠実に協議して対応することとします。求人企業は、かかる著作物に含まれる権利（知的財産権、肖像権等を含む）を有する第三者から、予め当社が当該著作物を自由に利用するために必要な許諾を得るとともに、当該利用に必要な権利処理の一切を行うものとします。なお、かかる著作物に関連して第三者からクレーム、請求等がなされた場合、求人企業の責任において対応をするものとし、当社は一切の責任を負わないものとします。 <br />
        7.求人企業は、本サービスに関して当社が一般に公開していない情報(本サービスに関する情報・仕組み・ノウハウ・プログラムソース等を含む)を、第三者に対し、一切開示または漏洩しないものとします。 <br />
        8.求人企業は、本サービスと類似したサービスまたはシステムを開発、提供または販売してはならないものとします。 <br />
        9.求人企業は、本システムの操作を第三者に委託する場合も、本条に定める求人企業の義務と同等の義務を当該第三者に負わせるものとします。ただし、それにより求人企業の責を免れるものではありません｡ <br />
        10.求人企業は、本サービスにおける利用履歴情報（過去のメッセージ内容など）等が、一定期間を経過すれば消去または非表示になることについて、予め承諾するものとします。 
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}>第７条（ID・パスワード）  </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        1.本サービスの利用におけるID・パスワード（以下「ID等」といいます。）の発行または管理等は、求人企業自ら行う必要があります。ID等の発行または管理等に関して、求人企業は一切の責任を負い対応するものとします。   <br />
        2.求人企業は、個人情報保護およびセキュリティ保持の必要上、ID等について厳重な管理義務を負います。求人企業は、第三者にID等を譲渡、貸与または開示等できません。ただし、求人企業が業務上の必要性からID等を業務委託先に使用させる場合には、求人企業の一切の責任においてこれを行うものとし、それにかかる事故等に関し、当社は何らの責任も負わないものとします。  <br />
        3.本サービスの利用にあたり企業登録において使用したID等について、登録日より60日以内に会社情報登録を行い登録申請がなされない場合や、企業審査にて当社が求人企業による本サービスの利用が不適切と判断した場合には、当社は企業登録において使用したID等の利用停止をすることができるものとします。 
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 第８条（求人情報および求人企業情報）  </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        1.求人企業は、求人情報をスカウト送信または掲載するにあたり、法令等を遵守する必要があります。 <br />
        2.求人企業は、本サービスにおける求人情報（職種、勤務地、賃金等）および求人企業情報（社名・所在地・代表者情報等）について、正確性・最新性・適法性等を保証することとします。求人企業は、本サービスにおける求人情報および求人企業情報について、定期的に見直しを行い、求人情報および求人企業情報に変更等があった場合には、速やかに変更するものとします。  <br />
        3.当社は、求人情報および求人企業情報について、本サービスの利用開始前後を問わず、当社基準に照らして審査します。当社は、当社基準に照らし、当該求人情報を本サービスで扱うことが不適切と判断した場合には、本サービスの利用開始前後を問わず、求人企業による本サービスの一部または全部の利用を禁止または停止することがあります。   <br />
        4.前項に基づく審査の結果、求人情報および求人企業情報が当社基準に反するまたは事実でないと、当社として判断した場合には、当社は、当該求人情報または求人企業情報を用いたスカウト送信および掲載を中止または停止し、求人企業に対して修正を求める権利を有します。この場合、求人企業が当該求人情報または求人企業情報を用いたスカウト送信および掲載を開始または再開することを希望する場合には、求人企業は、当社基準を満たした内容に修正するものとし、当社が修正内容について確認の上承認した場合に限り、スカウト送信および掲載を開始または再開することができるものとします。なお、当社は、修正内容の確認を可能な限り速やかに行うものとしますが、求人企業が希望する日時までに修正内容の確認を行うことを保証するものではありません。  <br />
        5.求人企業は、当社が、情報提供の多元化等を目的として、本サービスおよび本サービス以外のウェブサイトまたは各種メディア（以下「ウェブサイト等」といいます。）において、本サービス上の求人情報および求人企業情報を掲載することについて、予め承諾するものとします。  
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 第９条（スカウト） </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        1.求人企業は、自らが雇用主となる求人のスカウトしか送ることができないことを、予め承諾するものとします。   <br/>
        2.本サービスでは、利用会員が同一求人のスカウトを重複して受け取ることを防ぐ目的等で、求人企業が同一求人のスカウトを送信することができません。求人企業は、当該仕様について予め承諾するものとします。 <br />
        3.求人企業は、スカウトに関する情報（スカウトの内容の他、送信元、送信相手、送信回数、送信・返信日時、返信の有無、開封の有無等を含む）について、当社が以下の各号に定める目的で利用することについて、予め承諾するものとします。 <br />
        ① 求人企業が利用するサービスの運営およびそれに伴う利用会員等とのやりとり・情報提供  <br/>
        ② 求人企業への採用決定手数料の請求可否および内容に関する判断  <br />
        ③ 当社サービスの安全な運営に必要な問い合わせ・苦情等への対応、不正対策   <br />
        ④ 当社サービスの改善・新規開発<br />
        ⑤ 各種サービスの提案・情報提供  <br />
        ⑥ 上記の各利用目的に必要な各種調査・分析・マーケティング    
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 第１０条（連絡・採用選考） </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        1.求人企業は、採用選考にあたり、労働契約締結時の労働条件明示など、関係法令を必ず確認の上、遵守してください  <br />
        2.求人企業は、利用会員から連絡があった場合、５営業日以内に、当該利用会員に対して連絡（スカウトへの返信に対する回答、質問に対する回答を含みますが、これらに限られません。）を行うものとします。 <br />
        3.求人企業は、利用会員からスカウトへの返信または応募があった場合、必ず面談または採用面接を実施するものとします。ただし、当該利用会員より辞退する旨の意思表示があった場合または過去に同一求人に対して応募している場合には、この限りでありません。<br />
        4.求人企業は、利用会員からスカウトへの返信または応募があった場合、当該利用会員から過去１年以内に、本サービス以外の手段で応募があったかどうかを確認するものとします。   <br/>
        5.求人企業は、利用会員との採用選考を開始した後、以下の各号に定める事由が生じた場合、当該事由が生じた日から速やかに、当社に対して報告する必要があります。  <br />
        （１）利用会員の選考状況(選考開始・内定・内定承諾・入社・選考終了などを含みますがこれらに限りません)に変更があった場合 <br />
        （２）利用会員が、スカウトに対する返信または応募があった日より１年以内（採用選考中かどうかを問いません）に、当該利用会員から本サービス以外を経由して応募した場合<br/>
        6.求人企業は、本条第４項および第５項に定める場合の他、当社が指示する内容に従って、進捗を報告するものとします。  <br />
        7.本条第４項に基づく報告において、当該報告が当該利用会員に内定を提示する前であり、当社としても本条第４項に該当する事実を確認できた場合、当該利用会員に関しては採用決定手数料の対象から除かれるものとします。 <br />
        8.本条第５項第２号に該当する場合、求人企業は、本サービス以外の手段により当該利用会員が求人企業に入社した場合であっても、採用決定手数料を支払う必要があります。ただし、当該利用会員が、本サービス経由で求人企業に対し応募した時点で、既に、本サービス上での利用会員から求人企業に対する応募の結果が不合格である旨当該利用会員に通知がされている場合、または、利用会員が求人企業からのスカウトに対し辞退の意思表示をしている場合には、当該利用会員に関しては採用決定手数料の対象から除かれるものとします。   <br />  
        9.求人企業は、利用会員の採用を決定した場合、利用会員による内定承諾日から５営業日以内に、当社指定の方法に従い報告する必要があります。当社は、当該報告内容を、当社からの採用決定手数料の請求目的で用いる他、求人企業関連情報として利用することがあります。  <br />
        10.求人企業は、利用会員に対する選考開始後に、求人情報の一部または全部を変更したい場合、求人企業自ら、速やかに変更内容を利用会員に伝える必要があります。   <br />
        11.本規約第５条または第８条第４項に基づく審査の結果、本サービスを利用することが不適切であると当社が判断した場合、求人企業は本サービスを利用した採用選考を続けることができません。求人企業は、自らの責任で利用会員に対し説明等の対応を行ってください。  <br />
        12.求人企業は、連絡・採用選考およびメッセージ内容に関する情報（利用会員に対する連絡・採用選考の内容の他、送信元、送信相手、送信回数、送信・返信日時、返信の有無、開封の有無等を含む）について、当社が以下の各号に定める目的で利用することについて、予め承諾するものとします。   <br />
            ① 求人企業が利用するサービスの運営およびそれに伴う利用会員等とのやりとり・情報提供  <br />
            ② 求人企業への採用決定手数料の請求可否および内容に関する判断 <br/>
            ③ 当社サービスの安全な運営に必要な問い合わせ・苦情等への対応、不正対策   <br/>
            ④ 当社サービスの改善・新規開発   <br/>
            ⑤ 各種サービスの提案・情報提供   <br/>
            ⑥ 上記の各利用目的に必要な各種調査・分析・マーケティング   <br/>  
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 第１１条（利用会員情報の取り扱い）   </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        1.求人企業は、本サービスにおいて取得した利用会員情報を、当該求人企業における採用活動目的でのみ利用できます。利用会員情報を、利用会員が応募した求人情報とは別のポジションを打診するために利用したい場合は、求人企業は利用会員に対し誠実に説明の上、事前に同意を得る必要があります。利用会員の同意を得られない場合は、当初のポジションを前提に選考を進める必要があります。   <br/>    
        2.求人企業は、利用会員情報を機密として厳重かつ適正に取り扱うものとします。なお、求人企業において求人企業以外の第三者（グループ会社を含む）に利用会員情報を提供する等、前項の目的の範囲外で利用会員情報を利用したい場合は、求人企業の責任で法令等を確認の上、利用会員から事前に同意取得するなど、適切に対応する義務を負うものとします。  <br />
        3.求人企業は、利用会員情報を、求人企業以外の第三者に閲覧・利用・管理等ができるようにする場合は、求人企業の責任で、法令等を確認の上適切に対応する義務を負うものとします。  <br/> 
        4.求人企業による利用会員情報の使用および管理に関し、利用会員その他の第三者から当社に対して訴訟提起その他のクレームがなされた場合、かかるクレームや訴訟に対して、当社の責に帰すべき事由がない限り、求人企業は一切の責任と費用でこれを解決するものとし、当社が一切の責任を負わないことに同意するものとします。   
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 第１２条（当社による求人企業関連情報の利用および保管）   </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        1.求人企業は次の各号について、予め承諾するものとします。   <br />
        （１）当社が、本サービスを求人企業に提供するために必要な範囲において、利用会員情報および求人企業関連情報を利用すること   <br />
        （２）当社が、本サービスの向上・改善に必要な範囲において、調査・分析・マーケティング等を行うなどして、求人企業関連情報に基づく統計データやアルゴリズムを作成および利用すること（他の求人企業の求人企業関連情報と統合等した上で、統計データやアルゴリズムを作成等することを含む。）   <br />
        （3）当社が、前号に基づき作成した統計データやアルゴリズムについて、本サービスの向上・改善に限らず、何らの制限なく利用（求人企業および第三者への提案、市場の調査、サービス向上、新サービスの開発を含みますがこれらに限られません。）すること 
        2.当社は、求人企業と利用会員とのやりとりおよび個人情報を適正に管理しますが、当該情報の保管開始日から１年を超えたものについては、削除できるものとします。かかる場合には、削除の対象となった情報を求人企業が閲覧できなくなることについて、求人企業は予め承諾するものとします。  <br />    </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 第１３条（保守作業等による本サービスの運営の一時的な停止）   </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        1.当社は、次の各号に該当する場合には求人企業への事前の通知や承諾なしに、本サービスの内容を変更し、または、本サービスの正常な提供を行うために必要な期間、本サービスの提供を一時的に停止することができるものとし、求人企業は、これを予め承諾するものとします。   <br />
        （１）システム等の定期保守、点検、もしくは更新を行う場合、またはこれらを緊急に行う必要がある場合   <br />
        （２）通常のウィルス対策では防止のできないウィルスによる被害、火災、停電、天災地変等の不可抗力により、本サービスの提供が困難または不可能な場合 <br />
        （３）突発的なシステム等の故障等が発生した場合その他不測の事態の発生により、本サービスの提供が困難または不可能な場合   <br />
        （４）法令等の改正・成立により本サービスの提供が困難または不可能な場合    <br />
        （５）上記各号の他当社がやむを得ない事由により本サービスの提供の運営上一時的な停止が必要と判断した場合   <br />
        2.前項に定める本サービスの一時的な運営の停止により、求人企業が登録した求人企業情報の本サービス上への反映の遅れまたは利用会員からの応募等の受信の遅れが生じた場合により求人企業に損失が生じた場合でも、当社は、何らの責任も負わないものとします。    

        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 第１４条（本サービスに関する変更）   </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        1.求人企業は、当社が、本サービスに関する仕様およびシステム等について、事前の通知なく変更する場合があることを、予め承諾するものとします。   <br />
        2.当社は、前項の変更により求人企業に損害が生じた場合でも、何らの責任も負わないものとします。   
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}>第１５条（料金） </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        1.本サービスにて発生する料金については、以下各号の通りとします。なお、以下各号の料金については、求人企業が当社に対して支払うものとします。 <br />
        ① 利用会員が、本サービスを利用して求人企業へ入社をした場合の採用決定手数料   <br />
        ② 求人企業が、送付したスカウトメールで利用会員が開封したもの（１～50通まで1通あたり1,000円、51通以降は1通あたり1,500円。以下「スカウト開封メール」といいます。） <br />

        2.採用決定手数料について、求人企業が利用会員と合意した理論年収の１８％で算出される金額（税別）を当社に対して支払うものとします。ただし、利用会員から内定承諾のあった日が、利用会員から求人企業へエントリーのあった日から起算して２年を超える場合については、採用決定手数料の対象外とします。    <br />

        3.特定の利用会員に対して、複数の入社が発生する場合があります（同一の求人企業において異なる求人での入社が発生する場合も含む）。その場合、入社毎に、手数料を当社に対して支払うものとします。   <br />

        4.求人企業は、本契約が終了した後においても各料金の支払義務を負うものとします。   <br />

        5.求人企業は、自社採用求人に関して、理論年収が利用会員の入社後に変更になった場合であっても、当社に対して、利用会員の入社時の理論年収に基づき算出された採用決定手数料の支払義務を負うものとします。 <br />

        6.利用会員が、入社後3か月以内に、当該利用会員の責により解雇されるに至った場合、または当該利用会員が自己都合（当該利用会員の死亡による退職は除く）によって退職した場合、求人企業は当該利用会員の退職の事実を、当該退職日の翌月末日までに退職を証明できる書類データを当社に提出して報告するものとします。ただし、当社は、当該利用会員が退職した求人企業又は当該利用会員からも退職の事実を確認することができるものとします。 <br />

        7.前項により、退職の事実を当社が確認できた場合、受領した採用決定手数料について、求人企業から支払われた採用決定手数料の全額を返金するものとします。ただし、求人企業の破産、会社更生、民事再生に起因する退職は当該利用会員の責によるまたは自己都合のいずれにも該当しないものとし、採用決定手数料の返金の対象から除かれるものとします。   
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}>第１６条（請求および支払方法） </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        1.当社は、求人企業に対して手数料にかかる請求書（以下「請求書」といいます。）を送付するものとします。   <br />

        2.求人企業は、利用会員が求人企業への入社を確認した日（原則として入社日）の翌月末日までに当社指定の銀行口座へ振込送金方式により、手数料を支払わなければならないものとします。なお、振込手数料は求人企業の負担とする。   <br />

        3.求人企業は、スカウト開封メールの開封した日の翌月末日までに当社指定の銀行口座へ振込送金方式により、手数料を支払わなければならないものとします。なお、振込手数料は求人企業の負担とする。   <br />

        4.求人企業は、本サービスにより発生する手数料について支払が遅延したときは、当社に対して支払期日の翌日から完済に至るまでの期間について、年14.6％の割合（年365日日割り計算）による遅延損害金を支払うものとします。   
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 第１７条（契約期間）  </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        1.本契約の期間は、契約締結日より１年間とします。ただし、期間満了日の１か月前までにいずれの当事者からも何らの意思表示なき場合、同一の条件でさらに１年間更新されるものとし、その後も同様とします。   <br />
        2.本契約が終了した場合（理由を問いません。）であっても、①求人企業が本サービスを通じて選考した利用会員の入社日、②採用決定手数料の支払完了日のいずれか遅い日まで、本契約は必要な範囲で有効に存続することとします。   
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}>第１８条（規約の変更）    </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        当社は、本規約について重要な変更を行う場合には、変更内容・条件等（以下「変更条件」といいます。）の適用開始日の２週間以上前に求人企業に変更内容を通知するものとします。  <br />

        2.求人企業は、変更条件を承諾しない場合には、前項に基づく当該変更条件の通知日より２週間以内に、書面にて当社に対して通知する必要があります。当社が前項の通知を受領した場合は、当該変更条件適用開始日の前日をもって本契約は終了するものとします。   <br />

        3.前項の規定により本契約が終了する場合を除き、本規約は、適用開始日に、当該変更条件どおりに当然に変更されるものとします。  
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}>第１９条（損害賠償義務） </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        当社および求人企業は、本サービスに関連して相手方に損害を与えた場合、相手方の被った直接かつ通常の損害を賠償する義務を負います。   
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}>第２０条（免責）</Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        1.当社は、利用会員に対し、利用会員情報について正確性・最新性・適法性等を担保するように依頼していますが、当社としては一切保証しないものとします。  <br />

        2.当社は、求人企業に対し、利用会員の採用の確実性、利用会員の資質・能力等について、一切保証しないものとします。   <br />

        3.当社は、求人企業と利用会員の間に生じた一切のトラブルについて、当社の故意または重過失による場合を除き、何らの責任も負わないものとします。   <br />

        4.当社は、天災地変その他不可抗力（当社の責めに帰すべき事由によらない回線の輻輳、回線の障害、サーバダウン等を含む）により生じた損失につき、何らの責任も負わないものとします。   <br />

        5.当社は、本サービスに関する業務において通常要求される程度の合理的な措置を当社が講じていたにもかかわらず、求人企業または第三者の責めに帰すべき事由により生じた損失（①ウィルスによるサーバダウン、システム障害、データの流出・損壊および誤った情報の掲載、②ハッキングによるサーバダウン、システム障害、データの流出・損壊および誤った情報の掲載、③プロバイダのダウン、データの流出・損壊④求人企業の操作ミスによるデータの流出・損壊、採用機会の損失ならびに⑤システム環境の変化による障害、本サービスにかかるシステムの瑕疵などを含みますがこれらに限られません。）につき、何らの責任も負わないものとします。   <br />

        6.本条第４項および第５項に定める他、当社の過失の有無にかかわらず、本サービスにおいて発生する、利用会員による求人情報の閲覧の可能性、容易性に対する影響が軽微であると当社が合理的な理由に基づき判断する一切の事象（以下の各号に例示するものを含みますがこれらに限られません。なお、利用会員による当該求人への応募を不可能または著しく困難にする事象はこれには含まれません）について、当社は当該事象を商業的に合理的な範囲で改善するよう努めますが、それ以外は何ら責任を負わないものとします。   <br />

        （１）本サービスにおけるスカウト機能または求人検索機能の部分的、一時的な機能不全   <br />

        （２）求人情報の部分的、一時的な閲覧の不能（文字化け、文字の欠損、画像の非表示等を含みますが、これらに限られません。ただし、事業者が職業安定法第５条の３に基づき利用者に対して明示すべき労働条件の閲覧の不能はこれには含まれません）   <br />

        7.当社は、サービスの改善や新規開発を目的に、本サービスにおいて新しい商品や仕様の検証を行うことがあります。検証を行う際には、スカウト機能や利用会員検索機能において提供を保証している仕様に関しても、検証目的に照らし、当社が必要最低限と考える範囲に検証範囲や対象を限定した上で、仕様を変更することがあります。   <br />

        8.当社は、本サービスを提供するにあたり、第三者が運営するサービス等（以下「第三者サービス」といいます。）を用いることがあります。当社は、第三者サービスを用いた本サービスの提供に関しても、当社が本規約で定めている免責事項等について、求人企業に対し同様に主張できるものとします。   <br />
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}>第２１条（ペナルティ） </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        1.当社は、求人企業が以下の各号に該当する行為を行ったと合理的に判断した場合、求人企業への通知および承諾なしに直ちに本サービスの提供を一時的に停止または本契約を解除することができます。また、ペナルティとして、支払うべきだった採用決定手数料に加えて、当該採用決定手数料の２倍の金額を求人企業に対し請求できるものとします。仮に過失による行為であったとしても、以下の各号に該当する場合にはペナルティを請求しますので、採用決定に関する報告については、慎重にご対応ください。なお、本項は、求人企業による当該行為によって、当社にこれを上回る損害が生じた場合に、当社が求人企業に対して当該損害の賠償を請求すること、本サービスの一定期間の利用を停止または本契約を解除すること、その他当社との全部または一部の取引を終了することを妨げるものではありません。   <br />

        ① 採用決定に関する報告を、利用会員による内定承諾日から5営業日以内に行わない行為   <br />

        ② 採用決定に関する報告を、意図的に行わない行為   <br />

        ③ 採用決定に関する報告を、事実でない内容で報告する行為   <br />

        ④ 求人企業が採用決定手数料およびスカウト開封メールへの支払いを支払期日以降も意図的に行わない行為   <br />

        2.当社は、求人企業が前項に定める行為を複数回行ったと合理的に判断した場合、求人企業に対して該当する各行為に対しそれぞれペナルティを請求できるものとします。   
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}>第２２条（権利義務譲渡の禁止） </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        求人企業は、本契約上の地位に基づく一切の権利義務を、当社の事前の書面による承諾なく、第三者に譲渡もしくは貸与し、または担保に供してはならないものとします。   
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}>第２３条（禁止事項） </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        当社は、本サービスの利用に際して、求人企業が以下の各号に掲げる行為のいずれかを行い、または行うおそれがあると当社が合理的に判断した場合、求人企業への通知および承諾なしに直ちに本サービスの提供を一時的に停止し、または本サービスに関する契約を解除することができるものとします。   <br />

        （１）虚偽、不完全、不正確な情報を当社に対して提供しまたは本サービスを通じて閲覧に供する行為   <br />

        （２）個人情報保護法その他個人情報を保護する法令、その他日本国または地方公共団体が定める法令に違反し、または違反するおそれのある行為   <br />

        （３）当社または第三者の著作権、商標権等の知的財産権その他一切の権利を侵害する行為   <br />

        （４）本サービスの著作権者等に関する表示を変更・削除する行為   <br />

        （５）本規約、本契約または本サービスの利用目的に反する行為   <br />

        （６）本サービスのために利用するシステム等をリバースエンジニアリング、逆コンパイルまたは逆アセンブルする行為   <br />

        （７）本サービスのために利用するシステム等を改変し、または当該システム等に対して本規約により許諾された範囲外のアクセス（セキュリティ診断、検査その他アクセスの目的および方法を問いません。）等をする行為   <br />

        （８）自動巡回プログラム（RPAを用いたツールを含む）等、本サービスに関するシステムの全部または一部に過負荷をもたらすおそれのある行為   <br />

        （９）本サービスの運営を妨げる行為   <br />

        （１０）当社、利用会員、当社の顧客その他本サービスに関連するすべての第三者の名誉もしくは信用を毀損し、または毀損するおそれのある行為   <br />

        （１１）犯罪行為に結びつく行為または公序良俗に反する行為   <br />

        （１２）当社、利用会員、当社の顧客その他本サービスに関連するすべての第三者の機密情報または利用会員情報を、第三者に不法に公表・開示・提供・漏洩する行為   <br />

        （１３）利用会員に対し、違法または不適切な対応を取る行為   <br />

        （１４）他の求人企業による本サービスの利用を妨害する行為   <br />

        （１５）本サービスと類似したサービスまたはシステムを開発、提供または販売する行為   <br />

        （１６）本サービスのシステム画面を第三者に開示する行為   <br />

        （１７）その他求人企業への本サービスの提供を継続することが不適切であると当社が判断する行為   <br />

        （１８）利用会員と面談・面接を実施する想定のないスカウトを送信する行為   <br />

        （１９）法令に反する内容・労働条件等で雇用するまたはしようとする行為   

        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}>第２４条（反社会的勢力の排除）    </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        1.当社および求人企業は、現在、暴力団、暴力団員、暴力団員でなくなった時から５年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロまたは特殊知能暴力集団等、その他これらに準ずる者（以下これらを「暴力団員等」といいます。）に該当しないこと、および次の各号のいずれにも該当しないことを表明し、かつ将来にわたっても該当しないことを確約するものとします。   <br />

        （１）暴力団員等が経営を支配していると認められる関係を有すること   <br />

        （２）暴力団員等が経営に実質的に関与していると認められる関係を有すること   <br />

        （３）自己もしくは第三者の不正の利益を図る目的または第三者に損害を加える目的をもってするなど、不当に暴力団員等を利用していると認められる関係を有すること   <br />

        （４）暴力団員等に対して資金等を提供し、または便宜を供与するなどの関与をしている認められる関係を有すること   <br />

        （５）役員または経営に実質的に関与している者が暴力団員等と社会的に非難されるべき関係を有すること   <br />

        2.当社および求人企業は、自らまたは第三者を利用して次の各号の一にでも該当する行為を行わないことを確約するものとします。   <br />

        （１）暴力的な要求行為   <br />

        （２）法的な責任を超えた不当な要求行為   <br />

        （３）取引に関して、脅迫的な言動をし、または暴力を用いる行為   <br />

        （４）風説を流布し、偽計を用いまたは威力を用いて相手方の信用を毀損し、または相手方の業務を妨害する行為  <br />

        （５）その他前各号に準ずる行為   
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}>第２５条（契約の終了、解除）  </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        1.本契約の終了後は、本サービスの全部または一部を利用できなくなります。    <br />

        2.当社は、本契約の有効期間中であっても、求人企業に対して１か月前までに通知することにより、本契約の解除、本サービスの一部または全部の提供の終了または停止することができるものとします。    <br />

        3.前項にかかわらず、当社または求人企業は、相手方が次の各号の一に該当するときには、何ら事前の催告を要することなく、相手方に対し通知を行うことにより、即時に本サービスに関する契約を解除または本サービスの一定期間の利用の停止、その他相手方との全部または一部の取引を終了することすることができます。    <br />

        （１）本契約または求人企業と当社間のその他の契約に違反したとき   <br />

        （２）支払不能となったとき、支払を停止したとき、または手形交換所の不渡処分があったとき   <br />

        （３）公租公課を滞納したとき   <br />

        （４）差押、仮差押、仮処分、競売、強制執行、滞納処分等の公権力の処分を受けたとき   <br />

        （５）破産、民事再生、会社更生の申立がなされたとき、事業の全部もしくは重要な一部の譲渡・承継があったとき、営業の停止があったとき、解散の決議がなされたとき、もしくは清算に入ったとき、またはこれらの恐れがあるとき   <br />

        （６）代表者の所在が不明になったとき   <br />

        （７）債権者に対し、通常の時期、方法または態様によらない債務の弁済、担保提供等の事実があったとき   <br />

        （８）法令に違反したとき、または違反する恐れがあるとき   <br />

        （９）威嚇行為、脅迫行為、恫喝、暴力行為等を行ったとき   <br />

        （１０）受領遅滞、受領拒絶があったとき、他方当事者に対し、不当な要求を行う、不当な長時間の拘束を行う等、信頼関係が失われるような行為を行ったとき   <br />

        （１１）相手方の信用を傷付けたとき、または相手方に不利益をもたらしたとき   <br />

        （１２）監督官庁より営業の許可取消または停止の処分を受けたとき   <br />

        （１３）前各号の他、債権保全を必要とする事由が生じたとき等信用に不安が生じたとき   <br />

        （１４）前条（反社会的勢力の排除の条項）に定める表明保証に違反したとき   <br />

        （１５）第18条2項に基づき、本規約の変更内容について承諾しない旨の通知または受領したとき   <br />

        4.トラブル等から、求人企業による本サービスの利用が、当社または本サービスおよび本サービス等の信用等に影響を及ぼす可能性があると判断した場合には、何ら事前の催告を要することなく、求人企業に対し通知することにより、本サービスに関する契約を即時に解除することができるものとします。   <br />

        5.当社は、当社基準を求人企業が満たすか否かを判断する目的で、求人企業に対して資料等の提出を求めることができるものとし、求人企業は、速やかに当該資料等を提出するものとします。万が一、求人企業より当該資料等が提出されなかった場合、または、当該資料に基づき、当社において求人企業が当社基準を満たさないものであると判断した場合には、当社は、本サービスに関する契約を即時に解除することができるものとします。   <br />

        6.求人企業は、前３項の規定により本契約を解除された場合には、期限の利益を喪失し、直ちに当社に対する一切の債務を弁済するものとします。   
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}>第２６条（準拠法・合意管轄） </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        本規約および本契約は日本法を準拠法とし、本契約に関して生じる一切の紛争については、東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。   
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}>第２７条（存続条項） </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        本契約終了後においても、本規約第１０条（連絡・採用選考）、第１１条(利用会員情報の取り扱い)、第１２条(当社による求人企業関連情報の利用および保管)、第１５条(料金)、第１６条(請求および支払方法)、第１７条（契約期間）、第１９条(損害賠償義務)、第２０条(免責)、第２１条(ペナルティ)、第２３条(禁止事項)、第２６条(準拠法・合意管轄)、第２８条（協議解決）、第２９条（プライバシーポリシーとの適用関係）および本条は有効に存続します。 
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}>第２８条（協議解決） </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        本規約および運用ルール等の解釈に疑義が生じた場合、または本規約および運用ルール等に規定されていない事項については、当社と求人企業は、協議の上円満に解決するものとします。   
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}>第２９条（プライバシーポリシーとの適用関係）    </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
            1.個人情報に関する取扱いについては、本規約のほか、「プライバシーポリシー」が適用されます。   <br />
            2.本規約と「プライバシーポリシー」の定めに矛盾または抵触が存在する場合、「プライバシーポリシー」が本規約に優先するものとします。    
        </Typography>

        <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}>第３０条 付則  </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
        本規約は2025年1月27日より実施します。 <br />
        2025年5月1日　改定  <br />
        2025年10月20日　改定 
        </Typography>

        {/* <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 【本規約の制定日】 </Typography>
        <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'10px'}}> 
            2015年8月24日
        </Typography> */}

    {/*     
        <Button onClick={goBack} variant="contained" color="primary" style={{ marginBottom: '50px', marginTop: '20px' }}>
            前の画面に戻る
        </Button> */}
        </div>

        <div style={{width:"90%", margin: '0 auto', padding: '20px 0', fontFamily: '"Noto Sans JP", sans-serif' }}>
                <Typography variant="h6" className="HeaderContent" gutterBottom sx={{ padding:'0px 0px 20px 0px', fontFamily: '"Noto Sans JP", sans-serif'}} > プライバシーポリシー </Typography> 
                {/* <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> プライバシーポリシー  </Typography> */}
                <Typography className='paragraph-sx' variant="body2" gutterBottom sx={{textAlign: "left"}}> 株式会社ビジネスビジョン（以下「当社」といいます。）は、「転ナビ経理」上で提供するサービス（以下「本サービス」といいます。）における、本サービスをご利用になる方（以下「利用者」といいます。）の個人情報の取り扱いについて、以下のとおり、プライバシーポリシー（以下「本ポリシー」といいます。）を定めます。  </Typography>
        
                <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left", mt:4}}> 第１条　個人情報の取扱いについて   </Typography>
                <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
                当社は、本サービスをご利用になる方のプライバシーを尊重し、個人情報の管理に細心の注意を払い、これを取扱うものとします。  
                </Typography>
        
                <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 第２条　個人情報   </Typography>
                <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
                個人情報とは、利用者個人に関する情報であって、当該情報を構成する氏名、住所、電話番号、メールアドレス、学校名その他の記述等により、当該利用者を識別できるものをいいます。また、その情報のみでは識別できない場合でも、他の情報と容易に照合することができ、結果的に利用者個人を識別できるものも個人情報に含まれます。  
                </Typography>
        
                <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 第３条　個人情報の利用目的   </Typography>
                <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
                個人情報の利用目的は以下の通りです。利用目的を超えて利用することはありません。 <br />
                （1）本サービス利用者に対するサービスの提供  <br />
                （2）利用者の個人認証 <br />
                （3）本サービスの利用に伴う連絡・メールマガジン・DM・各種お知らせ等の配信・送付 <br />
                （4）属性情報・端末情報・位置情報・行動履歴等に基づく広告・コンテンツ等の配信・表示、本サービスの提供 <br />
                （5）本サービスの改善・新規サービスの開発およびマーケティング <br />
                （6）キャンペーン・アンケート・モニター・取材等の実施 <br />
                （7）本サービスに関するご意見、お問い合わせ <br />
                （8）当社と提携した国内外の事業者または企業への情報 <br />
                （9）当社の広告・宣伝・広報活動
                    </Typography>
        
                <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}>第４条　個人情報の変更等 </Typography>
                <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
                利用者は、本サービスにおいて登録した個人情報を、いつでも変更、追加することができます。 
                </Typography>
        
                <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 第５条　個人情報の第三者への開示   </Typography>
                <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
                利用者の個人情報について、利用者本人の同意を得ずに、本サービス利用企業等の第三者に開示することは、原則いたしません。提供先・提供情報内容を特定したうえで、利用者の同意を得た場合に限り開示します。ただし、以下の場合には、関係法令に反しない範囲で、利用者の同意なく利用者の個人情報を開示することがあります。  <br/>
                （1）国の機関若しくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合で、利用者本人の同意を得ることによりその事務の遂行に支障を及ぼすおそれがある場合 <br />
                （2）裁判所、検察庁、警察またはこれらに準じた権限を有する機関から、個人情報についての開示を求められた場合 <br />
                （3）公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、利用者本人の承諾を得ることが困難である場合 <br />
                （4）利用者が第三者に不利益を及ぼすと当社が判断した場合 <br />
                （5）利用者本人から明示的に第三者への開示または提供を求められた場合 <br />
                （6）法令により開示または提供が許容されている場合 <br />
                （7）合併その他の事由による事業の承継に伴い個人情報を提供する場合であって、承継前の利用目的の範囲で取り扱われる場合 
                </Typography>
        
                <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 第６条　個人情報の外部委託  </Typography>
                <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
                当社は、個人情報を取扱う業務の一部または全部を外部委託することがあります。当該委託先に個人情報の開示を行う場合には、十分な個人情報保護水準を確保していることを条件として委託先を選定し、機密保持契約を結んだ上で開示します。  
                </Typography>
        
                <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 第７条　仮名加工情報の作成   </Typography>
                <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
                当社は、取得した情報をもとに仮名加工情報を作成し、本サービスの改善および新サービスの開発のため利用することがあります。 
                </Typography>
        
                <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}>第８条　通話記録の保存について  </Typography>
                <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
                当社は、通話内容の確認、サービス品質の向上を目的として、電話等による通話記録を保存させていただく場合があります。  
                </Typography>
        
                <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 第９条　個人情報の管理   </Typography>
                <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
                当社は、個人情報への不当なアクセスまたは個人情報の紛失、破壊、改竄、漏洩等の危険に対して、技術面および組織面において必要な安全対策を継続的に講じるよう努めています。また、当社は、個人情報の保護に関する法令、業界規範・慣習、公序良俗を遵守します。  
                </Typography>
        
                <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 第１０条　免責事項    </Typography>
                <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
                当社は、以下の場合には、第三者による個人情報の取得に関し、何らの責任を負いません。  <br/>
                （1）本サービスサイトからリンクされる外部サイトにおいて、利用者から個人情報が提供され、またそれが利用された場合 <br />
                （2）当社の責によらず 利用者本人以外が利用者個人を識別できる情報（ID・パスワード等）を入手した場合 <br />
                （3）利用者自らが本サービスの機能または別の手段を用いて利用企業等に個人情報を明らかにする場合   
                </Typography>
        
                <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 第１１条　統計情報の利用    </Typography>
                <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
                当社は、提供された個人情報をもとに、個人を特定できないように加工した利用状況・統計データを作成することがあります。また、当該情報について何ら制約なく利用することができることとします。なお、この場合の著作権は当社に帰属することとします。  
                </Typography>
        
                <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 第１２条　プライバシーポリシーの変更    </Typography>
                <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
                当社は、法令等の定めがある場合を除き、プライバシーポリシーを随時変更することができるものとします。  
                </Typography>
        
                <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 第１３条　個人情報の開示請求   </Typography>
                <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
                当社は、「個人情報の利用目的」の通知、登録した個人情報の開示、訂正、追加または削除、利用停止、ならびに第三者への提供の停止（以下「個人情報の変更等」といいます。）を原則として利用者本人に限り求めることができるものとします。その際、当社は、利用者本人を確認させていただいたうえで、合理的な期間内に対応いたします。具体的な方法については、後掲の個人情報管理の問い合わせ先にご連絡ください｡ただし、以下の場合には、個人情報の変更等に応じないことがあります。  <br />
                （1）利用者本人または第三者の生命、身体、財産その他の権利・利益を害するおそれがある場合 <br />
                （2）本サービスの適正な実施に著しい支障を及ぼすおそれがある場合 <br />
                （3）他の法令に違反することとなる場合 <br />
                （4）当該個人情報の変更等に多額の費用を要する場合､その他、個人情報の変更等を行うことが困難な場合であって、利用者の権利・利益を保護するため必要なこれに代わるべき措置をとる場合 
                </Typography>
        
                <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 第１４条　本人確認について   </Typography>
                <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
                当社は、個人情報の開示、訂正、削除もしくは利用停止の求めに応じる場合等、個人を識別できる情報（氏名､住所､電話番号､生年月日､メールアドレス､会員番号､パスワード等）により、本人であることを確認します。ただし、本人以外が個人を識別できる情報を入手し使用した場合、当社は責任を負いません。  
                </Typography>
        
                <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}>第１５条　個人関連情報の取得および利用   </Typography>
                <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
                当社は、利用者のプライバシーの保護、利便性の向上、広告の配信、および統計データの取得のため、Cookieを使用します。また、当社は、CookieやJavaScript等の技術を利用して、サイト内における利用者の行動履歴（アクセスしたURL、コンテンツ、参照順等）を取得することがあります。ただし、行動履歴には個人情報は一切含まれません。 なお、Cookieの受け取りは、ブラウザの設定によって拒否することができます。拒否した場合、システムをご利用いただく上で一部機能に成約が生じることがあります。取得した属性情報および行動履歴など個人を特定できない情報について、当社は何ら制限なく利用することができるものとします。  
                </Typography>
        
                <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}>第１６条　個人情報保護管理者 </Typography>
                <Typography className='paragraph-sx' variant="body2" gutterButtom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
                個人情報保護管理者は、当社の代表取締役とします。  
                </Typography>
        
                <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> お問い合わせ窓口   </Typography>
                <Typography className='paragraph-sx' variant="body2" gutterBottom sx={{textAlign: "left", marginTop: '10px', marginBottom:'30px'}}> 
                個人情報に関する苦情および相談、開示等の問い合わせ先は、次の通りとします。 <br />
                部署名　人財事業部　<br />
                所在地　〒102-0093　東京都千代田区平河町1-9-5　第三大盛丸平河町ビル1階 <br />
                電　話　03-3288-5660 <br />
                メール　support@tennavi.com   
                </Typography>
        
                <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 本ポリシーは2025年1月27日より実施します。  </Typography>
                <Typography className='paragraph-sx' variant="body1" gutterBottom sx={{textAlign: "left"}}> 2025年9月1日　改定 </Typography>
                
                {/* <Button onClick={goBack} variant="contained" color="primary" style={{ marginBottom: '50px', marginTop: '20px' }}>
                前の画面に戻る
            </Button> */}
        </div>

    </>

  );
};

export default Terms;